import $ from "jquery"

// Password show/hide toggle for the book-layout auth forms. Clicking the eye
// button (.pw-toggle) flips its field between password and text. Replaces the
// old Stimulus "password-visibility" controller, which was never wired into the
// build (so the toggle did nothing). Delegated so it also works after turbo
// navigations.
$(document).on("click", ".pw-toggle", function (e) {
  e.preventDefault()
  const $btn = $(this)
  const $input = $btn.closest(".pw-field").find("input")
  if (!$input.length) return
  const show = $input.attr("type") === "password"
  $input.attr("type", show ? "text" : "password")
  $btn.html(show ? "&#128584;" : "&#128065;") // 🙈 / 👁
})
